import { forwardRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { Grid, InputLabel, Alert } from '@mui/material';
import { TextField } from 'mui-rff';
import { Form } from 'react-final-form';

import FormStateToRedux from '@components/FormStateToRedux';
import LobPropertiesJsonForm from '@components/LobPropertiesJsonForm/LobPropertiesJsonForm';
import ProdConfirmationDialog from '@components/ProdConfirmationDialog';

import {
  LOB_DETAILS_FORM_NAME,
  LOB_PROPERTIES_FORM_NAME,
} from '../../payment-options.constants';

function LOBDetailsForm({ initialValues = {}, submitError = '' }, ref) {
  const [openDialog, setOpenDialog] = useState({ show: false });

  const lobProperties = useSelector(
    (state) => state.forms[LOB_PROPERTIES_FORM_NAME],
  );

  const onSubmit = () => {
    // @TODO: implement
  };

  const validateForm = (values) => {
    const errors = {};
    if (!values.lobName) {
      errors.lobName = 'Required';
    }
    if (!values.lobCode) {
      errors.lobCode = 'Required';
    }
    if (lobProperties && !lobProperties.valid) {
      errors.lobProperties = 'Invalid';
    }

    return errors;
  };

  const handlePreSubmit = (e) => {
    e.preventDefault();
    setOpenDialog({ show: true }); // open the confirmation dialog if prod
  };

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={initialValues}
      validate={validateForm}
      render={({ handleSubmit, form }) => (
        <form
          onSubmit={(e) =>
            process.env.REACT_APP_ENV !== 'production'
              ? handleSubmit(e)
              : handlePreSubmit(e)
          }
          onReset={() => {
            form.reset(); // triggered by external reset button
          }}
          ref={ref}>
          <ProdConfirmationDialog
            openDialog={openDialog}
            yesHandler={handleSubmit}
          />
          <FormStateToRedux form={LOB_DETAILS_FORM_NAME} />

          {submitError && (
            <Alert
              sx={{ marginBottom: '10px' }}
              severity="error">
              {submitError}
            </Alert>
          )}

          <Grid
            container
            spacing={4}>
            <Grid
              item
              xs={12}
              md={4}>
              <Grid
                item
                xs={12}
                sx={{ marginBottom: '14px' }}>
                <InputLabel
                  id="merchant-name"
                  required
                  aria-required="true">
                  Name
                </InputLabel>
                <TextField
                  required
                  aria-label="merchant-name"
                  name="lobName"
                  margin="dense"
                  variant="outlined"
                />
              </Grid>
              <Grid
                item
                xs={12}
                sx={{ marginBottom: '14px' }}>
                <InputLabel
                  id="merchant-code"
                  required
                  aria-required="true">
                  OMS Order Type
                </InputLabel>
                <TextField
                  required
                  aria-label="merchant-code"
                  name="lobCode"
                  margin="dense"
                  variant="outlined"
                  disabled={initialValues.lobId !== undefined}
                />
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              md={8}>
              <LobPropertiesJsonForm
                name="lobProperties"
                data={initialValues.properties}
                label="Properties"
              />
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}>
            {submitError && (
              <Alert
                sx={{ marginTop: '10px' }}
                severity="error">
                {submitError}
              </Alert>
            )}
          </Grid>
        </form>
      )}
    />
  );
}

export default forwardRef(LOBDetailsForm);
